import { render, staticRenderFns } from "./in-year-budget-requests.vue?vue&type=template&id=38429359"
import script from "./in-year-budget-requests.ts?vue&type=script&lang=ts&external"
export * from "./in-year-budget-requests.ts?vue&type=script&lang=ts&external"
import style0 from "./in-year-budget-requests.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38429359')) {
      api.createRecord('38429359', component.options)
    } else {
      api.reload('38429359', component.options)
    }
    module.hot.accept("./in-year-budget-requests.vue?vue&type=template&id=38429359", function () {
      api.rerender('38429359', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/in-year-budget-requests.vue"
export default component.exports